import { Component, OnChanges } from '@angular/core';
import { INTERFACE_TYPE_ORCID, INTERFACE_TYPE_BIBTEX, INTERFACE_TYPE_EXCEL } from '../../../model/constants';
import { PublicationImportService } from '../../../service/publication-import.service';
import { PublicationImportInterfaceType } from '../../../model/publication-import-interface-type';
import { PublicationModuleOptions } from '../../../publication-module.options';

@Component({
    selector: 'res-publication-import-form',
    templateUrl: './publication-import-form.component.html'
})
export class PublicationImportFormComponent {

    public readonly moduleOptions = PublicationModuleOptions;

    public searchResultsAreDisplayed = false;
    interfaceTypes: PublicationImportInterfaceType[] = [];
    filteredInterfaceTypes: PublicationImportInterfaceType[] = [];
    interfaceTypesThatRequireSearchconfig: PublicationImportInterfaceType[] = [];
    selectedInterfaceType: PublicationImportInterfaceType;
    searchParams: {[key: string]: any} = {};

    constructor(private publicationImportService: PublicationImportService) {
        this.publicationImportService.loadImportSources().subscribe((interfaceTypes: PublicationImportInterfaceType[]) => {
            this.interfaceTypes = interfaceTypes;
            this.interfaceTypesThatRequireSearchconfig = interfaceTypes.filter(iT =>
                ![INTERFACE_TYPE_ORCID, INTERFACE_TYPE_BIBTEX, INTERFACE_TYPE_EXCEL].includes(iT.hisRepoType)
            );
            this.filteredInterfaceTypes = interfaceTypes;
        });
    }

    search(event: { query: string }) {
        this.filteredInterfaceTypes = this.interfaceTypes.filter(
            item => event.query === '' || item.systemName.toLowerCase().indexOf(event.query.toLowerCase()) !== -1
        );
    }

    get isInterfaceFromManifest() {
        return this.selectedInterfaceType?.hisRepoType && !this.isOrcidImport && !this.isBibTexImport && !this.isExcelImport;
    }

    get isOrcidImport() {
        return this.selectedInterfaceType?.hisRepoType === INTERFACE_TYPE_ORCID;
    }

    get isBibTexImport() {
        return this.selectedInterfaceType?.hisRepoType === INTERFACE_TYPE_BIBTEX;
    }

    get isExcelImport() {
        return this.selectedInterfaceType?.hisRepoType === INTERFACE_TYPE_EXCEL;
    }
}
